var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 20.3642L18.6795 22.6877L21.9602 21.14L12.2597 17.6268L2.56697 21.1399L5.84776 22.9041Z",
    fill: "#19C1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 8.3941L2.04688 4.69238V8.0114L12.2596 11.7131L22.4804 8.0114V4.69238L12.2596 8.3941Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2677 17.4145L22.4805 21.1162L22.4805 17.7972L12.2677 14.0955L2.04694 17.7972L2.04694 21.1162L12.2677 17.4145Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 5.23154L5.83768 2.9043L2.04688 4.69265L12.2596 8.39436L22.4804 4.69265L18.6896 2.9043L12.2596 5.23154ZM18.6795 3.12066L12.2596 5.44425L5.84776 3.12068L2.56697 4.66843L12.2597 8.18164L21.9602 4.66836L18.6795 3.12066Z",
    fill: "#19C1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdStation);
export default __webpack_public_path__ + "static/media/rd_station.9ef057ca.svg";
export { ForwardRef as ReactComponent };